import React, { useState } from 'react';
import avro from 'avsc';

const Validator = () => {
  const [schemaText, setSchemaText] = useState('');
  const [jsonText, setJsonText] = useState('');
  const [result, setResult] = useState('');

  const handleCheck = () => {
    setResult(''); // Очистить результат перед новой проверкой

    if (!schemaText) {
      setResult('Ошибка: AVRO схема не введена.');
      return;
    }

    if (!jsonText) {
      setResult('Ошибка: JSON для проверки не введён.');
      return;
    }

    let schema, data;

    // Парсим схему
    try {
      schema = JSON.parse(schemaText);
    } catch (e) {
      setResult(`Ошибка парсинга AVRO схемы:\n${e.message}`);
      return;
    }

    // Парсим JSON для проверки
    try {
      data = JSON.parse(jsonText);
    } catch (e) {
      setResult(`Ошибка парсинга JSON данных:\n${e.message}`);
      return;
    }

    // Создаём тип avro
    let type;

    try {
      type = avro.Type.forSchema(schema);
    } catch (e) {
      setResult(`Ошибка создания AVRO типа из схемы:\n${e.message}`);
      return;
    }

    // Проверяем данные
    const isValid = type.isValid(data);

    if (isValid) {
      setResult('JSON корректен согласно AVRO схеме.');
    } else {
      try {
        type.toBuffer(data); // Попытка сериализовать - если ошибка, значит данные не валидны
        setResult('JSON корректен согласно AVRO схеме.');
      } catch (e) {
        setResult(`JSON НЕ соответствует AVRO схеме:\n${e.message}`);
      }
    }
  };

  return (
    <div>
      <label htmlFor="schema">Введите AVRO схему (JSON):</label>
      <textarea 
        id="schema" 
        value={schemaText} 
        onChange={(e) => setSchemaText(e.target.value)} 
        placeholder='{
          "type": "record",
          "name": "User",
          "fields": [
            {"name": "name", "type": "string"},
            {"name": "age", "type": "int"}
          ]
        }'
      />

      <label htmlFor="jsonData">Введите JSON для проверки:</label>
      <textarea 
        id="jsonData" 
        value={jsonText} 
        onChange={(e) => setJsonText(e.target.value)} 
        placeholder='{
          "name": "Иван",
          "age": 30
        }'
      />

      <button onClick={handleCheck}>Проверить</button>

      {result && (
        <div className={`result ${result.includes('неверен') ? 'error' : 'success'}`}>
          {result}
        </div>
      )}
      
      <style jsx>{`
        textarea {
          width: 100%;
          height: 200px;
          font-family: monospace;
          font-size: 14px;
          padding: 10px;
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid #ccc;
          resize: vertical;
        }
        
        button {
          margin-top: 20px;
          padding: 10px 20px;
          font-size: 16px;
          cursor: pointer;
          border-radius: 4px;
          border: none;
          background-color: #007bff;
          color: white;
        }
        
        button:hover {
          background-color: #0056b3;
        }
        
        .result.success {
          background-color: #d4edda;
          color: #155724;
          border: 1px solid #c3e6cb; 
          padding: 15px; 
          margin-top: 20px; 
        }
        
        .result.error {
          background-color: #f8d7da; 
          color: #721c24; 
          border: 1px solid #f5c6cb; 
          padding: 15px; 
          margin-top: 20px; 
        }
        
        label {
            font-weight: bold; 
            display:block; 
            margin-top:20px; 
         }
       `}
       </style>
      
     </div>
   );
};

export default Validator;
